export function FullPageErrorFallback({
  message,
}: {
  message?: string | null | undefined;
}) {
  return (
    <div
      style={{
        fontSize: "1rem",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#1d1c1c",
        color: "#fff",
      }}
    >
      <p>There was an error loading this page</p>
      <p>Please verify the API URL is set correctly</p>
      {message === undefined || message === null ? null : (
        <p>The error message we received is: `{message}`</p>
      )}
    </div>
  );
}
